import { SelectedAccount } from '../contexts/authContext';

export const isUserLoggedIn = (loggedInAccount: SelectedAccount | null) => {
  return !!loggedInAccount && loggedInAccount.type === 'user';
};

export const isCompanyLoggedIn = (loggedInAccount: SelectedAccount | null) => {
  return !!loggedInAccount && loggedInAccount.type === 'company';
};
